import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
export function LoadingScreen({ gameId, label }) {
    const { t } = useTranslation();
    const text = label ?? gameId;
    return (_jsxs("div", { className: "loading-screen", "data-testid": "loading-screen", "aria-label": t('game.loading'), children: [_jsx("div", { className: "loading-screen__spinner", "aria-hidden": "true" }), text && _jsx("p", { className: "loading-screen__label", children: text })] }));
}
